'use strict';

// Wistia media for the welcome video. Users whose provider hides or locks features get the safe-mode cut.
const WELCOME_VIDEO_IDS = {
    standard: 'b64ej4t1s6',
    safe: 'n0dzr2wjb5',
};

const EMBED_OPTIONS = {
    videoFoam: true,
    settingsControl: true,
    fullscreenButton: true,
    playbar: true,
    volumeControl: true,
};

// Keep in sync with the safe-mode rule the users API applies to the invite emails
export function isSafeModeUser(user = {}) {
    return Boolean(
        user.hide_nutrition ||
            user.hide_ewg ||
            user.inhibit_swap ||
            user.inhibit_change_avoidances ||
            user.inhibit_autopopulate ||
            user.inhibit_change_nutrition_profile
    );
}

export function getWelcomeVideoUrl(safeMode = false, playerOptions = {}) {
    const id = safeMode ? WELCOME_VIDEO_IDS.safe : WELCOME_VIDEO_IDS.standard;
    const options = new URLSearchParams({ ...EMBED_OPTIONS, ...playerOptions }).toString();

    return `https://fast.wistia.net/embed/iframe/${id}?${options}`;
}
